export default "__VITE_ASSET__ac3a0f81__"